/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { STAR_WARS } from "../../assets/images";
export const TEST_DATA = [
    {
        idx: "51",
        title: "Craft-whisky-with-united-s-epitome-reserve.  No:555",
        subtitle:
            "Craft-whisky-with-united-s-epitome-reserve. No: 555",
        serialNo: "Rare #/51",
        img: "https://i.ibb.co/wSyCnnK/epitome-1.png/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.323,
            },
        ],
    },
    {
        idx: "52",
        title: "Craft-whisky-with-united-s-epitome-reserve. No:456",
        subtitle:
            "Craft-whisky-with-united-s-epitome-reserve. No:456",
        serialNo: "Rare #/52",
        img: "https://i.ibb.co/QdsfkY2/epitome-3.png/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.323,
            },
        ],
    },
    {
        idx: "53",
        title: "Craft-whisky-with-united-s-epitome-reserve. No:121",
        subtitle:
            "Craft-whisky-with-united-s-epitome-reserve. No:121",
        serialNo: "Rare #/53",
        img: "https://i.ibb.co/XZrhzG5/epitome-121.png/:/rs=w:1000",
        tag: "PLATINUM",
        category: "platinum",
        price: [
            {
                type: "fiat",
                currency: "USD",
                locale: "en-US",
                amount: 1200.0,
            },
            {
                type: "crypto",
                currency: "ETH",
                amount: 0.323,
            },
        ],
    },
    
];

export const FilterData = [
    {
        type: "button",
        title: "Type",
        key: "ex4",
        categories: [
            { label: "Crypto", value: "Crypto" },
            { label: "NFT", value: "NFT" },
        ],
    },
    {
        type: "button",
        title: "Country",
        key: "id-4",
        categories: [
            { label: "India", value: "Ind" },
            { label: "U.S.A.", value: "usa" },
            { label: "Canada", value: "canada" },
            { label: "Barbados", value: "barbados" },
            { label: "Dominica", value: "dominica" },
            { label: "Jamaica", value: "jamaica" },
        ],
    },
    {
        type: "checkbox",
        title: "Categories",
        key: "id-5",
        categories: [
            { label: "Music", value: "Music" },
            { label: "Adventure", value: "Adventure" },
            { label: "The Lord of the Rings", value: "The Lord of the Rings" },
            { label: "Star War", value: "Star War" },
            { label: "Life Is Beautiful ", value: "Life Is Beautiful " },
            { label: "Coachella", value: "Coachella" },
            { label: "Lollapalooza", value: "Lollapalooza" },
            {
                label: "Pitchfork Music Festival",
                value: "Pitchfork Music Festival",
            },
            { label: "Sci-Fi", value: "Sci-Fi" },
            { label: "The Godfather", value: "The Godfather" },
            {
                label: "Electric Daisy Carnival Las Vegas",
                value: "Electric Daisy Carnival Las Vegas",
                disabled: true,
            },
            { label: "Comedy", value: "Comedy" },
            { label: "Mystery", value: "Mystery" },
            { label: "Plants", value: "Plants" },
            { label: "Ultra Music Festival", value: "Ultra Music Festival" },
        ],
    },
    {
        type: "checkbox",
        title: "Time period",
        key: "id-6",
        categories: [
            { label: "2001-2004", value: "2001-2004" },
            { label: "2005-2008", value: "2005-2008" },
            { label: "2009-2012", value: "2009-2012" },
            { label: "2013-2016", value: "2013-2016" },
            { label: "2017-2020", value: "2017-2020", disabled: true },
            { label: "2021", value: "2021" },
        ],
    },
    {
        type: "range",
        title: "Price",
        key: "id-9",
        min: 0,
        max: 200,
        default: "ETH",
        subCategoriesTitle: "Currency",
        categories: [
            { label: "USD", value: "USD" },
            { label: "Ethereum", value: "ETH" },
            { label: "Indian Rupee", value: "INR" },
        ],
    },
];
